import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"bmth"> = {
  appId: "bmth",
  cookiePrefix: "bmth",
  lang: "EN",
  artist: {
    name: "Bring Me The Horizon"
  },
  meta: {
    description: "Bring Me The Horizon"
  },
  emailSender: {
    name: "IYK",
    email: "hello@notify.iyk.app"
  },
  admins: {
    mfaEnabled: true,
    otpExpiration: Duration.minutes(10),
    sessionDuration: Duration.minutes(20)
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0x1cc3d929b0d221bB87bF80bDF55418f08e0e98ec"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(1)
  },
  checkIn: {
    hidePrompt: true
  },
  shopUrl: "https://shop.bmthofficial.com",
  socialLinks: [
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://www.instagram.com/bringmethehorizon"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://tiktok.com/@officialbmth/"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/channel/UCAayZDDj3uom0QpSJiwLoUw"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/bmthofficial"
    },
    {
      platform: SocialPlatform.Discord,
      label: "Discord",
      href: "https://bmth.co/discordAW"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/bmthofficial/"
    },
    {
      platform: SocialPlatform.Spotify,
      label: "Spotify",
      href: "https://open.spotify.com/artist/1Ffb6ejR6Fe5IamqA5oRUF?si=opyADIgeSC6BNu-2j-dTgw"
    },
    {
      platform: SocialPlatform.AppleMusic,
      label: "Apple Music",
      href: "https://geo.itunes.apple.com/gb/artist/bring-me-the-horizon/121043936?mt=1&amp;app=music"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.webp`,
          width: 35
        },
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 80
          }
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: `${appConfig.s3.assets.appUrl}/how-to-tap.webp`,
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: "https://tools.sonymusiccreative.com/privacy/",
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
